import { render, staticRenderFns } from "./CarePage.vue?vue&type=template&id=12f65a97&"
import script from "./CarePage.vue?vue&type=script&lang=js&"
export * from "./CarePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports